<template>
  <v-card color='info' class='my-2'>
    <v-card-text class='white--text text-uppercase text-xs-center'>
      {{ text }}
    </v-card-text>
  </v-card>
</template>

<script>
/* --- Stepper Button ---
This will turn a card into a button. This is needed
because long text on buttons don't wrap on small screens.
Instead, the text is truncated. This will show the "button" as
a card, so that the text can be wrapped when its long.
*/
export default {
  name: 'stepper-button',
  props: {
    text: {
      required: true
    }
  }
}
</script>